/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class InboundLogReportService {
  private inboundLogUrl: string = environment.host + '/inboundLogs/filter';
  private inboundLogReportUrl: string = environment.host + '/report/InboundLogReport';
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getAllInboundLogs(payload: any, startRecord: any, recordsSize: any) {
    const filterURL = this.inboundLogUrl + '?pageMaxId=' + startRecord + '&size=' + recordsSize;
    return this.http.post(filterURL, payload).pipe(map((response) => response));
  }

  public getReportDetails() {
    const inboundReportUrl = this.inboundLogReportUrl;
    return this.http.get(inboundReportUrl).toPromise();
  }
}
